import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONTENT_LIMITS, contentLimitMessage } from '../../utils/contentLimits';
import './ContentLimitStatus.scss';

export default function ContentLimitStatus({ measurement, kind = 'comment' }) {
  const { t } = useTranslation();
  const error = contentLimitMessage(measurement.error, t);
  return <div className={`content-limit-status${error ? ' content-limit-status--error' : ''}`}>
    <span aria-label={t('brand:characterCount', { defaultValue: 'Characters' })}>
      {measurement.characters.toLocaleString()} / {CONTENT_LIMITS[kind].toLocaleString()}
    </span>
    {error && <p role="alert">{error}</p>}
  </div>;
}
